// extracted by mini-css-extract-plugin
export default {"list":"ProfileBlockDoctore_list__N5GDW","item":"ProfileBlockDoctore_item__BL4XI","data":"ProfileBlockDoctore_data__9Xqxr"};